var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"main-nav navbar bd-navbar is-fixed-top has-text-centered-mobile",attrs:{"role":"navigator","aria-label":"main navigation"}},[_c('a',{attrs:{"href":"https://addyinvest.ca"}},[_c('img',{staticClass:"navlogo",attrs:{"width":"90","height":"35","src":_vm.PrussianBluePath,"alt":"Logo orange"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }